module.exports = __webpack_public_path__ + "media/assets_v3/images/ziraat-bank-cbf647af174bf7abfe0c0323b5ce11af.png";